import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from '../../primitives/alert-dialog';
import { LoaderCircleIcon } from '../../svg/loader-circle-icon';

import type { JSX } from 'react';

interface AlertDialogConfirmationProps {
  action?: {
    cancel?: string;
    submit?: string;
  };
  description?: string | JSX.Element;
  id?: string;
  isLoading?: boolean;
  open: boolean;
  title: string | JSX.Element;
  onCancel: VoidFunction;
  onSubmit: VoidFunction;
}

export function AlertDialogConfirmation({
  action,
  description,
  id,
  isLoading = false,
  open,
  title,
  onCancel,
  onSubmit,
}: AlertDialogConfirmationProps) {
  return (
    <AlertDialog open={open}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>{title}</AlertDialogTitle>
          <AlertDialogDescription className="hidden" />
          <div className="text-sm [overflow-wrap:anywhere] text-muted-foreground">
            {description}
          </div>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel
            id={id ? `${id}-cancel` : undefined}
            className="min-w-32"
            disabled={isLoading}
            onClick={() => onCancel()}
          >
            {action?.cancel ?? 'Cancelar'}
          </AlertDialogCancel>
          <AlertDialogAction
            id={id ? `${id}-submit` : undefined}
            className="min-w-32"
            disabled={isLoading}
            onClick={onSubmit}
          >
            {isLoading ? <LoaderCircleIcon className="mr-1 animate-spin" /> : null}
            {action?.submit ?? 'Continuar'}
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}
